module.exports = __webpack_public_path__ + "img/filter.1490c8ac.svg";